import { Component, Input } from '@angular/core';
import { StatoAssistenza } from '@app/shared/models/assistenza';

interface IStatoAssistenzaBadge {
  class: string;
  icon: string;
  label: string;
}

@Component({
  selector: 'ser-stato-assistenza-badge',
  templateUrl: './stato-assistenza-badge.component.html',
  styleUrl: './stato-assistenza-badge.component.scss'
})
export class StatoAssistenzaBadgeComponent {

  @Input() stato: StatoAssistenza = StatoAssistenza.DaConfermare;
  @Input() onlyIcon: boolean = false;

  styles: { [key in StatoAssistenza] : IStatoAssistenzaBadge } = {
    Aperto: { class: 'bg-info', icon:'fa-plus', label: 'Aperto'  },
    DaConfermare: { class: 'bg-warning', icon:'fa-question', label: 'DaConfermare' },
    Confermato: { class: 'bg-success', icon:'fa-check', label: 'Confermato'  },
    Rifiutato: { class: 'bg-danger', icon:'fa-times', label: 'Rifiutato'  },
    ChiusoCasse: { class: 'bg-primary', icon:'fa-archive', label: 'Chiuso casse' },
    ChiusoPagamenti: { class: 'bg-gray-darker text-white', icon:'fa-box', label: 'Chiuso pagamenti' },
  }

}
